var _path, _path2, _ellipse, _path3, _path4, _path5, _polygon, _path6, _path7, _path8, _polygon2, _path9, _path10, _path11, _path12, _circle, _path13, _path14, _path15, _path16, _path17, _polygon3, _path18, _path19, _polygon4, _path20, _path21, _path22, _polygon5, _path23, _path24, _rect, _rect2, _rect3, _rect4, _polygon6, _polygon7, _rect5;

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgChefTwoColor(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    "data-name": "Layer 1",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 400 300",
    width: 406,
    height: 306,
    className: "illustration styles_illustrationTablet__1DWOa",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M245,141.58c-1.73-.21-3.46-.46-5.17-.81-1.39-.28-2.87,0-4.25-.34a5.07,5.07,0,0,1-3-2.71,7.36,7.36,0,0,1-1-3.45,4.58,4.58,0,0,1,1.28-3.27l2,3.79a5.51,5.51,0,0,1,1.87-3.86,20.85,20.85,0,0,1,2.73,4.24,13,13,0,0,1,1.31-3.92.74.74,0,0,1,.35-.39c.29-.11.58.16.78.41.66.84,1.27,2.22,2.12,2.8a18.88,18.88,0,0,0,2.23-3.18,9.8,9.8,0,0,1,3.55,5,23,23,0,0,0,2.42-4.34,6,6,0,0,1,2,3.81,8,8,0,0,0,1.61-2.76c.1-.36.28-.83.65-.78a.68.68,0,0,1,.39.26,5.14,5.14,0,0,1,1.25,3.29c0-.57,3.95-1.92,4.59-2.1a6.69,6.69,0,0,1-1.54,4.18,12.29,12.29,0,0,1-7.5,4.17A29.17,29.17,0,0,1,245,141.58Z",
    fill: "#ffd200"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M249.52,90.74a2.82,2.82,0,0,0-.88-1.08,1.09,1.09,0,0,0-1.3,0,1.67,1.67,0,0,0-.38,1.22l-.1,3.15a26.3,26.3,0,0,0-2.29-4.6c-1.1-1.75-2.72-3.52-4.78-3.49-.45,0-1,.17-1.09.6a1.23,1.23,0,0,0,.1.68c.61,1.71,1.43,3.35,1.9,5.1a7.25,7.25,0,0,1-.35,5.31,9.88,9.88,0,0,0-2.41-3.45c-.59-.55-1.48-1-2.17-.63a1.6,1.6,0,0,0-.6,1.55c.07.58.3,1.13.4,1.71.27,1.65-.64,3.26-1.65,4.6a12.87,12.87,0,0,0-2.59,4.26,6.11,6.11,0,0,0,2.16,6,9.58,9.58,0,0,0,6.21,2c3.28,0,9.26-.9,11.36-3.85,2-2.8,1.62-8.11,1.14-11.26A22.73,22.73,0,0,0,249.52,90.74Z",
    fill: "#e6e6e6"
  })), _ellipse || (_ellipse = /*#__PURE__*/React.createElement("ellipse", {
    cx: 201.01,
    cy: 242.38,
    rx: 148.12,
    ry: 14.58,
    fill: "#e6e6e6",
    opacity: 0.45
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M293.72,220.42s-11.44-3.12-13.93-13.77c0,0,17.73-3.59,18.23,14.71Z",
    fill: "#97c680",
    opacity: 0.58
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M295.12,219.29s-8-12.64-1-24.46c0,0,13.48,8.56,7.49,24.48Z",
    fill: "#97c680",
    opacity: 0.73
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M297.18,219.29s4.22-13.34,17-15.87c0,0,2.39,8.67-8.27,15.91Z",
    fill: "#97c680"
  })), _polygon || (_polygon = /*#__PURE__*/React.createElement("polygon", {
    points: "288.88 218.99 291.2 234.86 305.81 234.92 307.96 219.07 288.88 218.99",
    fill: "#24285b"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M133.74,78.56c7.26-9,21.71-7.29,26.44,3.22a30.22,30.22,0,0,1,2.38,11.07c1,22.8,12.76,35.23,23.56,31.3s16-23,16-23,8.83-6.3,10.79,0-6.21,6.34-6.21,6.34-10.5,61.64-56.27,22.2C121.51,104.77,126.3,87.73,133.74,78.56Z",
    fill: "#f4a28c"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M133.74,78.56c7.26-9,21.71-7.29,26.44,3.22a30.22,30.22,0,0,1,2.38,11.07c1,22.8,12.76,35.23,23.56,31.3s16-23,16-23,8.83-6.3,10.79,0-6.21,6.34-6.21,6.34-10.5,61.64-56.27,22.2C121.51,104.77,126.3,87.73,133.74,78.56Z",
    opacity: 0.08
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M152.09,50.45A33.07,33.07,0,0,1,154.4,59a2.68,2.68,0,0,1-2.52,2.85,6,6,0,0,1-5.79-2.82l-3-4a4.79,4.79,0,0,1,.44-5.53C145.78,46.57,151,47.38,152.09,50.45Z",
    fill: "#f4a28c"
  })), _polygon2 || (_polygon2 = /*#__PURE__*/React.createElement("polygon", {
    points: "143.61 54.95 141.55 72.35 151.36 73.51 148.9 60.28 143.61 54.95",
    fill: "#f4a28c"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M153.24,53.62l2,1.5a.86.86,0,0,1-.1,1.45l-1.82,1Z",
    fill: "#f4a28c"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "M149.12,61.4a6.16,6.16,0,0,1-2.66-1s-1.11,6.15,3.66,6.5Z",
    fill: "#ce8172",
    opacity: 0.31
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    d: "M147.44,55.94s-.67-1.95-2.09-1.32-.48,3.44,1.61,3.06Z",
    fill: "#f4a28c"
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    d: "M151,50.56a15.57,15.57,0,0,1-4.75,1.93s1.24,5.91-2.56,9.07c0,0-7.49-6.51-3.72-11.76,3.16-4.41,5.35-8.06,10.14-6.32A4,4,0,0,1,151,50.56Z",
    fill: "#24285b"
  })), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 136.14,
    cy: 48.61,
    r: 5.32,
    fill: "#24285b"
  })), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    d: "M147.47,55.34s-1.13-2.1-2.74-1-.54,3.62,2.08,3.73Z",
    fill: "#f4a28c"
  })), _path14 || (_path14 = /*#__PURE__*/React.createElement("path", {
    d: "M135.84,70.27l4.35.18a30.6,30.6,0,0,1,14.37,4.22c9.06,5.34,22.81,15.74,20.91,28.83-2.81,19.32-17.56,36.88-17.56,36.88L121.73,139S91.29,68.66,135.84,70.27Z",
    fill: "#97c680"
  })), _path15 || (_path15 = /*#__PURE__*/React.createElement("path", {
    d: "M131.71,77.47s19.48,14,7.78,38.61,3,23.7,3,23.7L121.73,139,118.35,130Z",
    opacity: 0.08
  })), _path16 || (_path16 = /*#__PURE__*/React.createElement("path", {
    d: "M134.76,84.21c-.92-9.81-13.22-13.92-19.9-6.68-4,4.39-7.3,10.92-7.42,20.56-.31,25.08-13,39.35-29,18.9A9.21,9.21,0,0,0,72,113.44c-3.26-.28-7.21,0-7.59,2.75-.73,5.4,3.43,5.64,6.29,5.2a3.64,3.64,0,0,1,3.78,1.83c3.13,5.69,12.12,19.15,26.24,17.07C116,138.05,137.57,114.1,134.76,84.21Z",
    fill: "#f4a28c"
  })), _path17 || (_path17 = /*#__PURE__*/React.createElement("path", {
    d: "M123.66,151.56l-10,31.76A32.6,32.6,0,0,1,96.6,203L82,210l.59,4.31,21.82-4.71a38.47,38.47,0,0,0,23.66-20.06l15.41-31.74Z",
    fill: "#f4a28c"
  })), _polygon3 || (_polygon3 = /*#__PURE__*/React.createElement("polygon", {
    points: "156.57 160.51 161.24 228.54 156.9 230.05 139.63 166.41 156.57 160.51",
    fill: "#f4a28c"
  })), _path18 || (_path18 = /*#__PURE__*/React.createElement("path", {
    d: "M162.13,229.71s.94,4,4,5.28,1.5,5.65-3.07,3a28.92,28.92,0,0,1-4-2.82,8.58,8.58,0,0,0-4.09-1.75,1.42,1.42,0,0,1-1.11-1.18c-.61-2.22,4.44-4.33,4.44-4.33Z",
    fill: "#97c680"
  })), _path19 || (_path19 = /*#__PURE__*/React.createElement("path", {
    d: "M82.59,214.27s-3.08,2.35-3,5.42-4.24,3.45-3.71-1.48a27.88,27.88,0,0,1,.85-4.54,7.94,7.94,0,0,0-.08-4.16,1.36,1.36,0,0,1,.59-1.4c1.67-1.37,5.4,2.13,5.4,2.13Z",
    fill: "#97c680"
  })), _polygon4 || (_polygon4 = /*#__PURE__*/React.createElement("polygon", {
    points: "120.44 136 159.44 138.08 165.66 192.17 102.55 189.56 120.44 136",
    fill: "#97c680"
  })), _path20 || (_path20 = /*#__PURE__*/React.createElement("path", {
    d: "M135.84,138.08s-6.31,7.45-10.73,24-4.48,28-4.48,28l-18.08-.58L120.44,136Z",
    opacity: 0.08
  })), _path21 || (_path21 = /*#__PURE__*/React.createElement("path", {
    d: "M159.44,138.08l8.23,37.73-28.81,1.73c3.74-19-18.42-41.54-18.42-41.54s19.45-19.51,26.11-32.76c1.54-3.06,2.4-5.78,2.18-7.85-1.18-11.08-16.66-25.07-16.66-25.07s2.33-.43,5.4-.77c5.15,6.71,22.66,22,23.8,16.09.65-3.38-1-4.08-6-10.61,1.44.8,4.13,2.43,4.13,2.43,1.88,1.24,3.71,5.47,5.77,7.1,1.64,1.29,12.44,9.06,13.35,15.14C180.69,114.15,159.44,138.08,159.44,138.08Z",
    fill: "#24285b"
  })), _path22 || (_path22 = /*#__PURE__*/React.createElement("path", {
    d: "M67.24,76.38l-2-8.88a1.55,1.55,0,0,0-1.86-1.17L52.08,68.9a1.54,1.54,0,0,0-1.16,1.86l2,8.91a6.91,6.91,0,0,0,2.91,4.24l5.2,3.5L69.9,126.2a1.14,1.14,0,0,0,1.36.86h0a1.14,1.14,0,0,0,.86-1.36L63.26,86.8l3.16-5.28A7,7,0,0,0,67.24,76.38Zm-6-6.59a.57.57,0,0,1,1.12-.26l2,8.86a.57.57,0,0,1-.43.68.56.56,0,0,1-.68-.42Zm-3.46.79a.59.59,0,0,1,.43-.68.58.58,0,0,1,.69.42l2,8.86a.57.57,0,0,1-.43.68.58.58,0,0,1-.68-.43Zm-3.46.78a.57.57,0,0,1,.43-.67.56.56,0,0,1,.68.42l2,8.86a.57.57,0,0,1-.43.68.58.58,0,0,1-.68-.43Z",
    fill: "#97c680"
  })), _polygon5 || (_polygon5 = /*#__PURE__*/React.createElement("polygon", {
    points: "222.68 102.01 222.72 103.31 201.49 99.54 201.01 102.27 222.8 106.14 223.02 114.2 250.86 119.14 255.37 107.81 222.68 102.01",
    fill: "#24285b"
  })), _path23 || (_path23 = /*#__PURE__*/React.createElement("path", {
    d: "M229.43,89.09a1.34,1.34,0,0,0-1.59.4,1.89,1.89,0,0,0-.12,1.33c.27,1.5,1.49,3.4,2.94,1.5C231.6,91.09,230.72,89.59,229.43,89.09Z",
    fill: "#e6e6e6"
  })), _path24 || (_path24 = /*#__PURE__*/React.createElement("path", {
    d: "M234.67,85.84A1.71,1.71,0,0,0,233,84.77c-.27,0-.58.16-.61.44a.73.73,0,0,0,.06.32,3.18,3.18,0,0,0,.68,1.22,1.08,1.08,0,0,0,1.29.23.83.83,0,0,0,.07-1.28",
    fill: "#e6e6e6"
  })), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 210.69,
    y: 142.89,
    width: 67.92,
    height: 8.66,
    fill: "#c9c9c9"
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: 216,
    y: 151.56,
    width: 57.29,
    height: 87.25,
    fill: "#e6e6e6"
  })), _rect3 || (_rect3 = /*#__PURE__*/React.createElement("rect", {
    x: 211.73,
    y: 138.52,
    width: 65.83,
    height: 4.37,
    fill: "#24285b"
  })), _rect4 || (_rect4 = /*#__PURE__*/React.createElement("rect", {
    x: 246.06,
    y: 134.35,
    width: 2.53,
    height: 4.18,
    fill: "#24285b"
  })), _polygon6 || (_polygon6 = /*#__PURE__*/React.createElement("polygon", {
    points: "233.12 140.09 235.65 140.09 233.12 135.91 230.6 135.91 233.12 140.09",
    fill: "#24285b"
  })), _polygon7 || (_polygon7 = /*#__PURE__*/React.createElement("polygon", {
    points: "261.53 140.09 259.01 140.09 261.53 135.91 264.06 135.91 261.53 140.09",
    fill: "#24285b"
  })), _rect5 || (_rect5 = /*#__PURE__*/React.createElement("rect", {
    x: 246.06,
    y: 161.51,
    width: 27.22,
    height: 70.82,
    fill: "#fff",
    opacity: 0.46
  })));
}

const ForwardRef = /*#__PURE__*/React.forwardRef(SvgChefTwoColor);
export default __webpack_public_path__ + "static/media/Chef_Two Color.963b0774b889fb0c1fde5d6b39030aec.svg";
export { ForwardRef as ReactComponent };